export default {
  CompositeList: ['試卷講評', '考試鞏固練'],
  examComment: {
    label1: '年級',
    label2: '考試時間',
    label3: '考試名稱',
    labelTime1: '開始時間',
    labelTime2: '結束時間',
    placeholder: '請輸入考試名稱',
    btn1: '試卷講評',
    checkClass: '請選擇班級',
    checksub: '請選擇學科',
    examination_type: [
      '練習考試',
      '周考試',
      '月考試',
      '期中考試',
      '期末考試',
      '模擬考試'
    ],
    gradeAll: '全部'
  },
  paperComments: {
    btn1: '導出',
    title1: '試卷概覽',
    title2: '試題分析',
    label1: '排序方式',
    title3: '答題情況',
    titlt4: '題型分布',
    answerLabel: '答    案',
    answerno: '未設置答案',
    knowlabel: '知識點',
    knowno: '未設置知識點',
    analyLabel: '解    析',
    analyno: '未設置解析',
    stat: '答題統計',
    intervaltit: '調整分數區間',
    stuList: '學生答題名單',
    stuTip: '（點擊作答選項，可查看學生留痕題卡）',
    notdata: '該考試下沒有試題',
    modalLabel: '分數區間',
    modaltext: '分一段',
    modalTip1: '註：該題滿分',
    modalTip2: '分',
    paperColor: ['容易', '較易', '一般', '較難', '困難'],
    columns: ['', '平均分', '最高分', '最低分'],
    sortList: ['按題號排序', '按班級得分率升序', '按班級得分率降序'],
    columnsType: ['題型名稱', '題號', '數量', '占比'],
    columnsExam: [
      '班級',
      '平均分',
      '得分率',
      '最高分',
      '最低分',
      '失分人數',
      '失分占比',
      '總分'
    ],
    columnsAnswer: ['序號', '學生姓名', '得分', '得分率', '作答'],
    ti: '題',
    tableData: ['班級', '年級'],
    quschild: '小題',
    rangeScorePlach: '請輸入數字',
    rangeScoreRules: '請輸入分數區間',
    see: '查看',
    noImg: '沒有答題卡圖片',
    noImg2: '學生未上傳圖片',
    examNum: '題號',
    answerAll: ['', '年級'],
    seteSuccess: '分數區間設置成功',
    analysisChart: {
      formatter: '得分率',
      xAxisName: '題號',
      yAxisName: '得分率(%)'
    },
    downPdfTip: '下載中，請稍後...',
    downStudentScore: '下載學生成績單',
    downStudentDetaial: '學生答題明細下載'
  },
  consolodata: {
    examTime: '考試日期',
    getquestion: '去獲取題目信息',
    release: '發布鞏固練',
    valiquestion: '驗證題目',
    down: '下載',
    more: '更多',
    del: '刪除',
    proModaltit: '下載考試鞏固練習進度',
    protip: '正在加載，請勿進行其他操作，加載完成後，點擊確定進行下載',
    pronum: '數據隊列',
    downModaltit: '選擇下載的班級',
    downoktext: '確定下載',
    downlabel1: '下載範圍',
    downType1: '按班級下載',
    downType2: '按學生分組下載',
    checkAll: '全選',
    downlabel2: '下載格式',
    relaseModaltit: '考試鞏固練發布',
    relaselabel1: '發布方式',
    publishType0: '分層發布',
    publishType1: '個性發布',
    relaselabel2: '分層方式',
    level1: '第一層次：年級前',
    level2: '第二層次：年級中',
    level3: '第三層次：年級後',
    levelrate: '推題難度：易、中、難比例為',
    relaselabel3: '個性方式',
    yi: '易',
    zhong: '中',
    nan: '難',
    relaselabel4: '試卷題量',
    byorinum0: '大概30分鐘題量',
    byorinum1: '原考試試卷題量',
    relaselabel5: '發布試卷',
    tao: '套',
    class: '選擇班級',
    againtit: '重新獲取題目信息',
    againtip: '發布失敗，需要重新校對信息！',
    againtip2: '聯系運營人員',
    againBtn: '重新獲取',
    columns: [
      '學科',
      '獲取題目信息時間',
      '發布鞏固練時間',
      '發布方式',
      '驗證狀態',
      '發布人',
      '任務管理'
    ],
    isChecked0: '未完成驗證',
    isChecked1: '已完成驗證',
    has_permissions: '您沒有考試安排的權限，無法獲取變式題，請聯系管理員！',
    downSucess: '下載成功',
    seLockStatus: '請先發布成績再發布鞏固練',
    noClass: '獲取到的班級為空',
    publishSuccess: '發布成功',
    downNum: ['個性化推送', '層級一', '層級二', '層級三'],
    eleMsg: '等待中...',
    noSelect: '沒有選擇班級或者組，請選擇班級再下載',
    delTit: '重新獲取信息',
    delTit1: '删除',
    delcontents:
      '確認刪除後，需要重新獲取考試題目信息後，才能再次發布鞏固練，並且新生成的內容與這次不同。是否繼續？',
    delcontents1:
      '确认删除后，再次发布巩固练时新生成的内容与这次不同，是否继续？',
    delsucess: '刪除成功'
  }
}
